import React, { useState, ReactNode } from 'react';
import Button from '@amzn/awsui-components-console/button';
import Popover from '@amzn/awsui-components-console/popover';
import StatusIndicator from '@amzn/awsui-components-console/status-indicator';

interface CopyableTextProps {
	textToCopy: string;
	label: string;
	children: ReactNode;
}

const CopyableText: React.FC<CopyableTextProps> = ({ textToCopy, label, children }) => {
	const [copyStatus, setCopyStatus] = useState<'success' | 'error'>('success');
	const [statusMessage, setStatusMessage] = useState(`${label} copied`);

	const handleCopy = async () => {
		try {
			await navigator.clipboard.writeText(textToCopy);
			setCopyStatus('success');
			setStatusMessage(`${label} copied`);
		} catch (error) {
			setCopyStatus('error');
			setStatusMessage('Failed to copy to clipboard');
		}
	};

	return (
		<>
			{children}
			<Popover
				size="small"
				position="top"
				triggerType="custom"
				dismissButton={false}
				content={<StatusIndicator type={copyStatus}>{statusMessage}</StatusIndicator>}
			>
				<Button
					iconName="copy"
					variant="icon"
					ariaLabel={`Copy ${label}`}
					onClick={handleCopy}
				/>
			</Popover>
		</>
	);
};

export default CopyableText;
